import React from "react";
import { Typography } from "../Typography/Typography";
import { getDisplayStatus } from "../../../utils/status-utils";
import { REQUEST_STATUS, RequestStatusLabel } from "../../../constants/status";
import { useTranslation } from "react-i18next";
import "./RequestStatusBadge.scss";

function RequestStatusBadge({ type }: Readonly<{ type: REQUEST_STATUS }>) {
  const { t } = useTranslation();
  return (
    <Typography
      className={`badge-container status-${getDisplayStatus(type)}`}
      variant="flag"
      component="span"
    >
      {t(RequestStatusLabel[type])}
    </Typography>
  );
}

export default RequestStatusBadge;
